import { Component, OnInit } from '@angular/core';
import { StatusChipComponent } from '../../../../../shared/components/status-chip/status-chip.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-medica-telefonica-confirm',
  imports: [StatusChipComponent, MatIconModule, CommonModule],
  templateUrl: './medica-telefonica-confirm.component.html',
  styleUrl: './medica-telefonica-confirm.component.scss'
})
export class MedicaTelefonicaConfirmComponent {

   
  expediente = '';
  fecha = '';
  hora = '';
  precio = '$0.00';
  cubierto = true;
  expanded = true;
  hideHeaderDiv: boolean = false;
  serviceData: any = null;
  patientName: string = '';
  telefono: string = '';

  constructor(private router: Router) {}


  toggleExpand() {
    this.expanded = !this.expanded;
  }



  contactar() {
    if (this.telefono) {
      window.location.href = `tel:${this.telefono}`;
    } else {
      console.log('No hay teléfono disponible');
    }
  }

  openWhatsApp() {
    const phoneNumber = this.telefono || '5555555555';
    const message = `Hola, necesito información sobre mi Consultoría Médica Telefónica. Expediente: ${this.expediente}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  }
}
